<template>
	<div class="responsive-note">
		<h3 class="mt-12 font-weight-black">Encurtar Url</h3>
		<v-card class="mt-5 d-flex align-start" width="1219" height="130">
			<div class="rounded borderGreen" style="height: 120px; width: 3px !important; background-color: var(--green); margin: 5px"></div>
			<div class="">
				<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Url</span>
				<span class="d-flex align-center">
					<input
						placeholder="Insire a URL longa aqui."
						v-model="urlLong"
						class="mt-3 pl-2 responsive-input-long" 
						style="border: 2px solid var(--grey-day-020); height: 48px; width: 900px; margin-left: 40px; margin-right: 20px; border-radius: 4px"
					>
					<v-btn
						width="226"
						height="48"
						class="mt-2"
						:disabled="urlLong === ''"
						:style="
							urlLong !== '' ? 'background: var(--red); color: var(--white)' : 'background: var(--white); color: var(--black)'"
						@click="requestShortUrl"
					>
						<img :src="urlLong === '' ? '../../../../static/images/encurtador_grey.svg' : '../../../../static/images/short_white.svg'"/>
						<span class="pl-3 ff">Encurtador de Url</span>
					</v-btn>
				</span>
			</div>
		</v-card>


	<transition name="slide">	
		<v-card v-if="openResponse" class="mt-5 d-flex align-start" width="1219" height="130">
			<div class="rounded borderGreen" style="height: 120px; width: 3px !important; background-color: var(--blue); margin: 5px"></div>
			<div class="">
				<span class="font-weight-black pt-6 pl-10 d-flex flex-column" style="font-size: 14px">Sua Url Encurtada</span>
				<span class="d-flex align-center">
					<input
						v-on:focus="$event.target.select()" 
						ref="clone"
						v-model="shorterUrl"
						class="mt-3 d-flex align-center pa-5 responsive-input-short"
						style="border: 2px solid var(--grey-day-020); height: 48px; width: 975px; margin-left: 40px; margin-right: 20px; border-radius: 4px; background: var(--grey-day-020)"
					/>
					<v-btn
						width="150"
						height="48"
						class="mt-2"
						@click="copy"
						color="var(--red)"
					>
						<img src="../../../../static/images/square_white.svg"/>
						<span class="pl-3 ff" style="color: var(--white)">{{copyText}}</span>
					</v-btn>
				</span>
			</div>
		</v-card>
	</transition>
	</div>
</template>
<script>
// Lib
import { mapState, mapActions, mapMutations } from 'vuex'

import VueCookies from 'vue-cookies'

export default {
	data () {
		return {
			urlLong: '',
			copyText: 'Copiar',
			shorterUrl: '',
			openResponse: false
		}
	},
	computed: {
		...mapState('UrlTools', {
			url: 'url',
			shortUrl: 'shortUrl'
		}),
		hasUrlShort () {
			return this.url.shortUrl
		}
	},
	methods: {
		...mapActions('UrlTools',{
			requestUrl: 'requestUrl'
		}),
		...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
		async requestShortUrl () {
			const token = VueCookies.get('jwt-login')
			try {
				const urlLongWhiteSpace = this.urlLong.split(' ')
				if (urlLongWhiteSpace.length > 1) {
					this.toaster(
						'URL contém espaço em branco',
						'danger',
						true
					)
					return 
				} else {
					const response = await this.requestUrl([
						{
							longUrl: this.urlLong
						},
						token
					])
					this.shorterUrl = this.url.shortUrl
					this.openResponse =  true
					if (response.status >= 400) {
						throw new Error(response.data.message)
					} else {
						this.toaster(
							'URL encurtada com sucesso',
							'var(--green)',
							true
						)
					}
				}
			} catch (e) {
        this.toaster(e.message, 'danger', true)
      }
		},
		copy () {
      this.$refs.clone.focus()
      document.execCommand('copy')
    },
		toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
	}
}
</script>
<style lang="">
@media screen and (max-width: 1377px) {
	.responsive-note {
		width: 817px
	}
	
	.borderGreen {
		padding-left: 4px;	
	}
	.responsive-input-long {
		width: 500px !important;
	}
	.responsive-input-short {
		width: 575px !important;
	}
}

/* Slide transitions */
.slide-enter { 
  opacity: 0;
}

.slide-enter-active {
  animation: slide-in .5s ease-in forwards;
  transition: opacity .5s;
}

.slide-leave-active {
  animation: slide-out .5s ease-out forwards; 
  opacity: 0;
  transition: opacity 1s;
}


@keyframes slide-in {
  from {
    transform: translateY(-20px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(20px);
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/UrlTools/ShortnerCreate.vue